import { getNodeViewDecorators } from "./../../../../ricos-common-plugins/viewer.js";
import { BreakoutDecorator } from "./breakout-decorator.js";
import { Decorators as NodeViewDecorators } from "./node-view-decorators.js";
const getDecorators = (plugins) => [...getNodeViewDecorators(plugins), BreakoutDecorator];
export {
  NodeViewDecorators,
  getDecorators
};
//# sourceMappingURL=index.js.map
